import * as Highcharts from 'highcharts/highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import BrokenAxis from 'highcharts/modules/broken-axis';
import {Options} from "highcharts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

let chartPlugins: Map<String, typeof AbstractChart> = new Map<String, typeof AbstractChart>();

/**
 * Default options applied to Highcharts overall, as opposed to chart specific options that are specified in the respective plugins.
 */
let defaultOptions: Options = {
    chart: {
        backgroundColor: '#fff',
        height: 300,
        spacingTop: 25,
        spacingRight: 15,
        spacingBottom: 13,
        spacingLeft: 15,
        style: {
            fontFamily: "'Inter', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida', 'Verdana', 'Geneva', sans-serif"
        }
    },
    xAxis: {
        tickLength: 0,
        title: {
            useHTML: true,
            style: {
                fontSize: '12px',
                fontWeight: '300'
            }
        },
        labels: {
            useHTML: true,
            style: {
                fontSize: '10px',
                fontWeight: '300'
            }
        }
    },
    yAxis: {
        title: {
            text: null, // Disable title per default
            useHTML: true,
            style: {
                fontSize: '12px',
                fontWeight: '300'
            }
        },
        labels: {
            useHTML: true,
            style: {
                fontSize: '10px',
                fontWeight: '300'
            }
        }
    },
    title: {
        text: <string>null, // Disable title per default
        useHTML: true,
        style: {
            fontSize: '16px'
        }
    },
    legend: {
        useHTML: true,
        margin: 5,
        itemDistance: 5,
        symbolPadding: 2,
        itemStyle: {
            fontSize: '11px',
            fontWeight: 'normal',
            color: 'rgb(102, 102, 102)'
        }
    },
    colors: [
        '#3366cc',
        '#dc3912',
        '#ff9900',
        '#109618',
        '#990099',
        '#434348',
        '#8085e9',
        '#f15c80',
        '#e4d354',
        '#2b908f'
    ],
    tooltip: {
        enabled: false,
        formatter: function () {
            return `${this.series.name}: <b>${this.y.toFixed(1)}</b>`;
        }
    },
    credits: {
        enabled: false
    },
    exporting: {
        enabled: false
    },
    plotOptions: {
        series: {
            animation: false // Avoid problems with PDF,
        },
        bar: {
            maxPointWidth: 18
        },
        column: {
            maxPointWidth: 18
        },
        pie: {
            showInLegend: true,
            allowPointSelect: true,
            dataLabels: {
                enabled: true,
                useHTML: true,
                distance: -50
            }
        }
    },
};

function createCharts() {
    $('.chart').each(function () {
        const pluginClass = chartPlugins.get($(this).data('name'));
        const pluginInstance: AbstractChart = Reflect.construct(pluginClass, [this]);
        pluginInstance.createChart();
    });
}

/**
 * At another layer, default Highchart options can be overridden by e.g. using a module in the following way (here for custom color scheme):
 *
 * import {Options} from "highcharts";
 * import {setDefaultOptions, default as init} from "surveylabJsAssets/chart/charts";
 *
 * export default function () {
 *   setDefaultOptions({
 *       colors: ['#072AC8', '#1E96FC', '#A2D6F9']
 *   });
 *   init();
 * }
 */
export function setDefaultOptions(options: Options) {
    defaultOptions = Highcharts.merge(defaultOptions, options);
}

export function registerPlugin(plugin: typeof AbstractChart) {
    chartPlugins.set(plugin.name, plugin);
    return plugin;
}

export default function () {
    $(function () {
        HighchartsMore(Highcharts);
        BrokenAxis(Highcharts);

        // Workaround CSP violation: https://github.com/highcharts/highcharts/issues/6173#issuecomment-276905452
        // @ts-ignore
        // noinspection JSUnusedGlobalSymbols
        Highcharts.Tooltip.prototype.applyFilter = function () {};

        // Override error handling in order to throw all errors
        // @ts-ignore
        Highcharts.error = function (code: number | string) {
            throw 'Highcharts error #' + code + ': www.highcharts.com/errors/' + code;
        };

        Highcharts.setOptions(defaultOptions);

        createCharts();
    });
}